import * as Yup from 'yup';

export const userForm = [
  {
    name: 'firstName',
    initialValue: '',
    validation: Yup.string(),
    input: {
      label: 'First name',
    },
  },
  {
    name: 'lastName',
    initialValue: '',
    validation: Yup.string().required('Last name is required'),
    input: {
      label: 'Last name',
    },
  },
  {
    name: 'name',
    initialValue: '',
    validation: Yup.string()
      .email('Invalid email address.')
      .required('Email is required'),
    input: {
      label: 'Email',
      type: 'email',
    },
  },
  {
    name: 'userGroupID',
    initialValue: '',
    validation: Yup.number().required('User group is required'),
    input: {
      label: 'Select group',
      as: 'select',
      options: [],
    },
  },
  {
    name: 'cardCode',
    initialValue: '',
    validation: Yup.string().required('PIN is required'),
    input: {
      label: 'PIN',
      className: 'pin',
      type: 'password',
    },
  },
  {
    name: 'password',
    initialValue: '',
    validation: Yup.string().required('Password is required'),
    input: {
      label: 'Password',
      className: 'password',
      type: 'password',
    },
  },
];

export const usersTable = [
  {
    key: 'name',
    title: 'Name',
    className: 'w-100',
  },
  {
    key: 'email',
    title: 'Email',
  },
];
